var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-expandable-parent",style:({
        maxHeight: _vm.parentHeight ? _vm.parentHeight + 'px' : null,
        transition: 'max-height ' + _vm.transitionTimeString,
        })},[_c('div',{ref:"contentElement",staticClass:"text-expandable-content"},[_c('span',{class:_vm.expanded ? 'text-show-breaks' : ''},[_vm._v(_vm._s(_vm.displayContent))]),(_vm.hasMore)?_c('b-link',{staticClass:"text-uppercase font-size-70 font-weight-bold ml-2",on:{"click":_vm.toggleExpand}},[_vm._v(_vm._s(_vm.expanded ? _vm.toggleTextOpen : _vm.toggleTextClosed))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }